import type { TrackingErrorCtors, TrackingErrorReason } from './types.js';

/** Map an unknown error to a {@link TrackingErrorReason} for failure-event reporting. */
export function classifyTrackingError(error: unknown, ctors: TrackingErrorCtors): TrackingErrorReason {
  if (error instanceof ctors.ApiError) {
    const { status } = error;
    if (status === 400 || status === 422) {
      return 'validation';
    }
    if (status === 401 || status === 403) {
      return 'unauthorized';
    }
    if (status === 404) {
      return 'not_found';
    }
    if (status === 409) {
      return 'conflict';
    }
    if (status === 410) {
      return 'gone';
    }
    if (status >= 500) {
      return 'server_error';
    }
    return 'client_error';
  }
  if (ctors.TimeoutError && error instanceof ctors.TimeoutError) {
    return 'timeout';
  }
  if (error instanceof ctors.NetworkError) {
    return 'network';
  }
  // Third-party SDKs still reject with the bare TypeError a raw `fetch` produces.
  if (error instanceof TypeError) {
    return 'network';
  }
  return 'unknown';
}
